import React from "react";
import { Grid, TextField, Paper, Typography } from "@material-ui/core";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import { COLORS } from "../styles";

interface TransferDetailsFormProps {
  refillsRemaining: string;
  quantityRemaining: string;
  quantityTransferred: string;
  lastFillDate: string;
  writtenDate: string;
  expirationDate: string;
  onRefillsRemainingChange: (value: string) => void;
  onQuantityRemainingChange: (value: string) => void;
  onQuantityTransferredChange: (value: string) => void;
  onLastFillDateChange: (value: string) => void;
  onWrittenDateChange: (value: string) => void;
  onExpirationDateChange: (value: string) => void;
  fieldErrors?: { [key: string]: string };
  disabled?: boolean;
}

const TransferDetailsForm: React.FC<TransferDetailsFormProps> = ({
  refillsRemaining,
  quantityRemaining,
  quantityTransferred,
  lastFillDate,
  writtenDate,
  expirationDate,
  onRefillsRemainingChange,
  onQuantityRemainingChange,
  onQuantityTransferredChange,
  onLastFillDateChange,
  onWrittenDateChange,
  onExpirationDateChange,
  fieldErrors = {},
  disabled = false,
}) => {
  return (
    <Grid item xs={12} style={{ marginTop: 24 }}>
      <Paper
        elevation={2}
        style={{
          padding: 24,
          borderRadius: 8,
          backgroundColor: "#f5f5f5",
        }}
      >
        <Typography
          variant="h6"
          style={{
            fontWeight: 600,
            marginBottom: 16,
            color: COLORS.textPrimary,
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <SwapHorizIcon style={{ color: "#546e7a" }} />
          Transfer Details
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              id="transfer-refillsRemaining"
              name="refillsRemaining"
              label="Refills Remaining"
              variant="outlined"
              type="number"
              value={refillsRemaining}
              onChange={(e) => onRefillsRemainingChange(e.target.value)}
              fullWidth
              required
              disabled={disabled}
              error={!!fieldErrors.refillsRemaining}
              helperText={
                fieldErrors.refillsRemaining ||
                "Must be less than medication's total refills"
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="transfer-quantityRemaining"
              name="quantityRemaining"
              label="Quantity Remaining"
              variant="outlined"
              type="number"
              value={quantityRemaining}
              onChange={(e) => onQuantityRemainingChange(e.target.value)}
              fullWidth
              required
              disabled={disabled}
              error={!!fieldErrors.quantityRemaining}
              helperText={fieldErrors.quantityRemaining}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="transfer-quantityTransferred"
              name="quantityTransferred"
              label="Quantity Transferred"
              variant="outlined"
              type="number"
              value={quantityTransferred}
              onChange={(e) => onQuantityTransferredChange(e.target.value)}
              fullWidth
              required
              disabled={disabled}
              error={!!fieldErrors.quantityTransferred}
              helperText={fieldErrors.quantityTransferred}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="transfer-lastFillDate"
              name="lastFillDate"
              label="Last Fill Date"
              variant="outlined"
              type="date"
              value={lastFillDate}
              onChange={(e) => onLastFillDateChange(e.target.value)}
              fullWidth
              required
              disabled={disabled}
              error={!!fieldErrors.lastFillDate}
              helperText={fieldErrors.lastFillDate}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="transfer-writtenDate"
              name="writtenDate"
              label="Written Date"
              variant="outlined"
              type="date"
              value={writtenDate}
              onChange={(e) => onWrittenDateChange(e.target.value)}
              fullWidth
              required
              disabled={disabled}
              error={!!fieldErrors.writtenDate}
              helperText={fieldErrors.writtenDate || "Synced with medication written date"}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="transfer-expirationDate"
              name="expirationDate"
              label="Expiration Date"
              variant="outlined"
              type="date"
              value={expirationDate}
              onChange={(e) => onExpirationDateChange(e.target.value)}
              fullWidth
              required
              disabled={disabled}
              error={!!fieldErrors.expirationDate}
              helperText={fieldErrors.expirationDate}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default TransferDetailsForm;
